var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Consumer } from './scrollContext';
var Section = function Section(_ref) {
  var id = _ref.id,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, ['id', 'children']);
  return React.createElement(Consumer, null, function (_ref2) {
    var registerRef = _ref2.registerRef;
    return React.createElement('section', _extends({
      ref: registerRef(id),
      id: id
    }, rest), children);
  });
};
Section.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Section ID */
  id: PropTypes.string.isRequired,
  /** Section content */
  children: PropTypes.node
} : {};
Section.defaultProps = {
  children: null
};
export default Section;